export default __webpack_public_path__ + "static/media/Energy Conversion.31c227f8.png";